<template>
  <div>
    <!-- کارت اصلی محصول -->
    <v-card class="glass-card world-class-product-card mb-4" elevation="5" @click="sheet = true">
      <div class="d-flex pa-3 align-center">
        
        <div class="product-info flex-grow-1 d-flex flex-column pl-3 justify-center">
          <div>
            <h3 class="text-subtitle-1 font-weight-bold grey--text text--darken-4 mb-1" style="line-height: 1.3;">
              {{ value.name }}
            </h3>
            <p 
              v-if="value.description"
              class="grey--text text-caption text-justify overflow-hidden" 
              style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; line-height: 1.4; margin-bottom: 8px;"
              v-html="value.description"
            ></p>
          </div>

          <div class="d-flex justify-space-between align-end mt-2">
            <div class="price-section d-flex flex-column">
              <span v-if="!!computedOption.discount_amount" class="text-decoration-line-through grey--text text-caption" style="line-height: 1;">
                {{ use_lang(price(computedOption.price)) }}
              </span>
              <div class="d-flex align-center">
                <span class="font-weight-black text-body-1" :class="!!computedOption.discount_amount ? 'red--text' : 'grey--text text--darken-4'">
                  {{ use_lang(price(priceWithDiscount)) }}
                </span>
                <span class="grey--text text-caption mr-1">{{ currencySymbol || 'ریال' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="product-image-container position-relative flex-shrink-0 ml-1">
          <v-img 
            :src="thumbnail || defaultImage" 
            class="rounded-lg elevation-1 bg-white" 
            height="110" 
            width="110" 
            style="object-fit: cover; background-color: #f9f9f9;"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon color="grey lighten-2" size="40">mdi-image-outline</v-icon>
              </v-row>
            </template>
          </v-img>

          <div v-if="!!computedOption.discount_amount" class="discount-badge">
            {{ use_lang(price(computedOption.discount_amount)) }}
            <span v-if="computedOption.discount_type !== 'price'">٪</span>
          </div>

          <div class="action-btn-wrapper" @click.stop>
            <!-- <cart-actions
              v-model="computedValue"
              :max-order="computedOption.max_order"
              :optionId="hasOptions ? computedOption.id : null"
              :pending="sheet"
              :specialId="value.special?.[0]?.id || null"
            /> -->
          </div>
        </div>

      </div>
    </v-card>

    <!-- مودال (Bottom Sheet) نمایش جزئیات کامل محصول هنگام کلیک روی کارت -->
    <v-bottom-sheet v-model="sheet" scrollable inset max-width="500">
      <v-card class="rounded-t-xl pb-2" elevation="9">
        <!-- هدر مودال -->
        <v-card-title class="d-flex justify-space-between align-center pt-4 pb-2">
          <span class="text-h6 font-weight-bold grey--text text--darken-4">{{ value.name }}</span>
          <v-btn icon color="grey darken-1" @click="sheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pt-0">
          <!-- عکس بزرگ محصول در مودال -->
          <v-img 
            v-if="thumbnail"
            :src="thumbnail" 
            height="220" 
            class="rounded-lg mb-4 mt-2 elevation-1"
            style="object-fit: cover; background-color: #f9f9f9;"
          ></v-img>
          
          <!-- توضیحات کامل -->
          <p v-if="value.description" class="text-body-2 grey--text text--darken-2 text-justify mb-5" style="line-height: 1.8;" v-html="value.description"></p>
          
          <!-- اگر آپشن یا وریانت خاصی دارید (مثل انتخاب سایز یا مخلفات)، کد آن را اینجا قرار دهید -->

          <!-- بخش قیمت و دکمه خرید در مودال -->
          <div class="d-flex justify-space-between align-center mt-4 pa-3 rounded-lg" style="background-color: #f8f9fa; border: 1px solid #eeeeee;">
            <div class="price-section d-flex flex-column">
              <span v-if="!!computedOption.discount_amount" class="text-decoration-line-through grey--text text-caption">
                {{ use_lang(price(computedOption.price)) }}
              </span>
              <div class="d-flex align-center">
                <span class="font-weight-black text-h6" :class="!!computedOption.discount_amount ? 'red--text' : 'grey--text text--darken-4'">
                  {{ use_lang(price(priceWithDiscount)) }}
                </span>
                <span class="grey--text text-caption mr-1">{{ currencySymbol || 'ریال' }}</span>
              </div>
            </div>
            
            <div @click.stop>
              <!-- <cart-actions
                v-model="computedValue"
                :max-order="computedOption.max_order"
                :optionId="hasOptions ? computedOption.id : null"
                :specialId="value.special?.[0]?.id || null"
              /> -->
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<style scoped>
.glass-card {
  background: rgba(255, 255, 255, 0.45) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 3px solid rgba(255, 255, 255, 0.8) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14) !important;
  overflow: visible;
  transition: all 0.3s ease;
}

.glass-card:active {
  transform: scale(0.98);
}

.world-class-product-card {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  border-radius: 16px !important;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  height: 100%; /* برای یکدست شدن در گرید دسکتاپ */
}

/* افکت هاور ملایم برای حالت دسکتاپ */
.world-class-product-card:hover {
  box-shadow: 0 4px 15px rgba(0,0,0,0.05) !important;
  border-color: #e0e0e0;
}

.product-image-container {
  width: 110px;
  height: 110px;
  margin-bottom: 12px; /* فضا برای دکمه شناور */
}

.discount-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #e53935;
  color: white;
  font-weight: bold;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 6px;
  z-index: 2;
}

/* استایل دکمه اکشن شناور */
.action-btn-wrapper {
  position: absolute;
  bottom: -16px; /* آوردن به لبه پایینی عکس */
  left: 50%;
  transform: translateX(-50%); /* مرکز کردن دقیق زیر عکس */
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
  padding: 2px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f0f0f0;
  min-width: 80px; /* حداقل عرض برای دکمه تا در هنگام 0 بودن هم شکل خوبی داشته باشد */
}

/* کوچک کردن آیکون‌های کامپوننت cart-actions برای ظرافت بیشتر در کارت */
.action-btn-wrapper >>> .v-btn {
  height: 28px !important;
  width: 28px !important;
}

/* گرد کردن لبه‌های بالای مودال bottom-sheet */
.rounded-t-xl {
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
}
</style>

<script>
import { mapState } from "vuex";
import ExtraShown from "@/view/components/Product/extraShown";
// import CartItem from "../../fragments/cart/CartItem.vue";
// import CartActions from "../../fragments/cart/CartActions.vue";

export default {
  name: "mProductCard",
  components: { ExtraShown },
  
  props: {
    value: Object,
    currencySymbol: {
      type: String,
      default: 'ریال'
    },
    cartButtonText: {
      type: String,
      default: 'افزودن'
    },
    defaultImage: {
      type: String,
      default: "/img/default-placeholder.png", 
    }
  },
  
  data: () => ({
    openMap: false,
    sheet: false,
    loading: false,
    product: {},
    selectedColor: 0,
  }),
  
  mounted() {
    if (this.value?.options?.length && this.value.options instanceof Array) {
      let colors = this.value.options.filter((item) => item.type === "color");
      this.selectedColor = colors.length ? 0 : null;
    }
  },
  
  watch: {
    sheet(isOpen) {
      this.$root.$emit("sheet-state-change", isOpen);
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  
  computed: {
    ...mapState("cart", ["cart"]),


    computedValue: {
      get() {
        let currentOptionId = this.hasOptions ? this.computedOption.id : null;
        let itemInCart = this.cart.find(
          (c) => 
            c.id === this.value.id && 
            (c.optionId == currentOptionId || c.option_id == currentOptionId)
        );
        return {
          ...this.value,
          count: itemInCart ? itemInCart.count : 0
        };
      },
      set(val) {
        if (!this.validateCount(val.count)) return;
        this.$store.dispatch("cart/changeCount", {
          id: this.value.id,
          optionId: this.hasOptions ? this.computedOption.id : null,
          specialId: this.value.special?.[0]?.id || null,
          count: val.count,
        });
        this.$emit("input", val);
      },
    },
    hasDetails() {
      return (
        this.value.details?.filter(
          (item) => !!item.label || !!item.value || !!item.icon || !!item.link
        )?.length > 0
      );
    },
    priceWithDiscount() {
      const discount =
        Number(this.value.special?.[0]?.total_discount) ||
        Number(this.computedOption.discount_amount) ||
        0;
      if (discount) {
        if (this.computedOption.discount_type === "price") {
          return this.computedOption.price - discount;
        }
        return Math.floor((this.computedOption.price * (100 - discount)) / 100);
      }
      return this.computedOption.price;
    },
    colors() {
      return this.value.options instanceof Array
        ? this.value.options.filter((item) => item.type === "color")
        : [];
    },
    hasOptions() {
      return !!this.colors?.length && this.selectedColor != null;
    },
    computedOption() {
      let obj = this.hasOptions ? this.colors[this.selectedColor] : this.value;
      return {
        ...obj,
        price: obj.price || this.value.price, 
        discount_amount: Number(this.value.special?.[0]?.total_discount || obj.discount_amount || 0),
        discount_type: this.value.special?.[0]?.total_discount ? "percent" : obj.discount_type || "percent",
        max_order: obj.max_order || this.value.special?.[0]?.max_per_order || this.value.max_order || 100,
      };
    },

    thumbnail() {
      let gallery = !!this.value?.gallery
        ? typeof this.value?.gallery === "string"
          ? JSON.parse(this.value.gallery)[0]
          : this.value.gallery[0]
        : { name: "", images: [] };
      return gallery?.images?.length > 0 ? gallery.images[0].url : "";
    },
    hasExtra() {
      let e = !!this.value.extra && typeof this.value.extra === "string" ? JSON.parse(this.value.extra) : [];
      return e.filter((item) => !!item.label || !!item.value || !!item.icon || !!item.link)?.length > 0;
    },
    computedExtra() {
      return !!this.hasExtra ? JSON.parse(this.value.extra) : [];
    },
  },
  methods: {
    validateCount(count) {
      const maxPerCustomer = this.value.special?.[0]?.max_per_customer || Infinity;
      const totalInCart = this.$store.state.cart.cart
        .filter(
          (x) =>
            x.id === this.value.id &&
            x.optionId === (this.hasOptions ? this.computedOption.id : null) &&
            x.specialId === (this.value.special?.[0]?.id || null)
        )
        .reduce((sum, x) => sum + x.count, 0);
      if (totalInCart + count > maxPerCustomer) {
        this.$toast.error(this.$t("procart.max_per_customer_exceeded", { max: maxPerCustomer }));
        return false;
      }
      return true;
    },
    changeLocation(route) {
      let id = this.$store.state.local.qr_id;
      localStorage.setItem("qr", id);
      this.gotoApp("/cart");
    },
  },
};
</script>
